import * as React from 'react';
import { useBetslipContext } from '@cx-web/feature-betslip/context';
// providers
import { useLabelActions } from '@cx-web/feature-i18n';
// services
import { buildBetOnBookmakerSiteEvent, trackBetslipEvent } from '@cx-web/feature-tracking/betslip';
import Icon from '@cx-web/icons';
import { Button } from '@fpsm/cxy-components/Button';

// hooks
// styles
import styles from '../style/betslip.module.css';

const ButtonSection = () => {
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);

  const labelActions = useLabelActions();
  const { count: numberOfBets, handleClearBetslip, handleClickoutToPlaceBet, selectedBookie } = useBetslipContext();

  if (!mounted) return null;

  if (numberOfBets === 0) {
    return null;
  }

  return (
    <div className={styles.buttonSection}>
      <Button className={`${styles.button} ${styles.clearButton}`} onClick={handleClearBetslip}>
        {labelActions.get('DELETE_ALL')}
      </Button>
      <Button
        className={`${styles.button} ${styles.clickoutButton}`}
        onClick={() => {
          trackBetslipEvent(buildBetOnBookmakerSiteEvent(selectedBookie?.bookmakerCode));
          handleClickoutToPlaceBet();
        }}
      >
        <Icon height={16} icon="Clickout" width={16} />
        {labelActions.get('BET_ON_BOOKMAKER_WEBSITE')}
      </Button>
    </div>
  );
};

export default ButtonSection;
